<h2 mat-dialog-title>Tierart</h2>
<mat-dialog-content>
    <mat-form-field style="width: 100%">
        <input
            type="text"
            disabled="true"
            matInput
            placeholder="Tierart"
            [(ngModel)]="tierart.bezeichnung"
            [attr.data-cy]="'ttdtd_input_1_1_'"
        />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <input
            type="text"
            disabled="true"
            matInput
            placeholder="Kürzel"
            [(ngModel)]="tierart.kuerzel"
            [attr.data-cy]="'ttdtd_input_2_1_'"
        />
    </mat-form-field>
</mat-dialog-content>
<mat-checkbox [formControl]="mnp_rind_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_1_3_'">Maßnahmenplan Rind</mat-checkbox
><br />
<mat-checkbox [formControl]="gt_eight_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_2_3_'">&gt; 8 Monate</mat-checkbox
><br />
<mat-checkbox [formControl]="mnp_schwein_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_3_3_'"
    >Maßnahmenplan Schwein</mat-checkbox
><br />
<mat-checkbox [formControl]="gt_thirty_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_4_3_'">&gt; 30 kg</mat-checkbox><br />
<mat-checkbox [formControl]="hit_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_5_3_'">HIT</mat-checkbox><br />
<mat-checkbox [formControl]="qs_ctrl" [attr.data-cy]="'ttdtd_mat-checkbox_6_3_'">QS</mat-checkbox><br />
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" [attr.data-cy]="'ttdtd_button_1_0_'">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="save()" [attr.data-cy]="'ttdtd_button_2_0_'">Speichern</button>
</mat-dialog-actions>
